module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/layouts/quick-sidebar/quick-sidebar.component.html
// module id = ./src/app/theme/layouts/quick-sidebar/quick-sidebar.component.html
// module chunks = main